import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  variant?: 'default' | 'highlight';
}
export function Card({
  children,
  className = '',
  variant = 'default',
  ...props
}: CardProps) {
  const baseStyles = 'rounded-2xl p-6 md:p-8 relative overflow-hidden';
  const variants = {
    default: 'glass-card',
    highlight: 'bg-gradient-to-b from-[#D4A843]/10 to-transparent border border-[#D4A843]/30 shadow-[0_0_30px_rgba(212,168,67,0.1)]'
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-201">
      {children}
    </motion.div>;
}